module.exports = __webpack_public_path__ + "static/media/teambuildings.2fe527b4.svg";